import { TilledLogo } from 'src/common/primitives/logos/TilledLogo';

export function RejectedTilledMerchantApplication() {
  return (
    <>
      <div
        data-testid="rejected-tilled-merchant-application"
        className="flex flex-grow flex-row items-center gap-2"
      >
        <TilledLogo />
        <div>
          Your application has been rejected by Tilled, please contact Tilled
          for more information.
        </div>
      </div>
    </>
  );
}
